import { useGoogleAnalytics } from "@connectaryal/google-analytics";
import { MenuItem } from "@fluentui/react-components";
import PropTypes from "prop-types";
import * as React from "react";
import { useSelector } from "react-redux";

const TrackedMenuItem = React.forwardRef(function TrackedMenuItem(props, ref) {
  const { trackEngagement } = useGoogleAnalytics();
  const presentationHash = useSelector((state) => state.app.presentation.hash);

  return (
    <MenuItem
      {...props}
      ref={ref}
      onClick={(e) => {
        if (props.onClick) props.onClick(e);
        trackEngagement({
          type: "click",
          options: { id: props?.id ?? props?.key ?? "UNIDENTIFIED", presId: presentationHash },
        });
      }}
    />
  );
});

TrackedMenuItem.propTypes = {
  id: PropTypes.string,
  key: PropTypes.string,
  onClick: PropTypes.func,
};

export default TrackedMenuItem;
